import { DB } from "../api/supabase";
import { normalizeBuyerName } from "./buyerName";

// Refresh display fields only. Roles and session credentials must never come
// from user-editable Auth metadata or the profile row.
export async function restoreBuyerProfile(session, authUser) {
  if (!authUser?.id || authUser.id !== session.id) {
    throw new Error("저장된 계정 정보를 확인할 수 없습니다. 다시 로그인해 주세요.");
  }
  let profile = null;
  try {
    const rows = await DB.getProfile(session.token, authUser.id);
    if (!Array.isArray(rows)) throw new Error("PROFILE_LOOKUP_FAILED");
    profile = rows.find(row => row.id === authUser.id) || null;
  } catch {
    // Auth was already verified; use its fresh metadata if profiles is unavailable.
    console.warn("프로필 조회 실패: 최신 인증 계정 정보로 복원합니다.");
  }
  const meta = authUser.user_metadata || {};
  return {
    ...session,
    name: normalizeBuyerName(profile?.name ?? meta.name ?? session.name),
    company: profile?.company ?? meta.company ?? session.company ?? "",
    tel: profile?.tel ?? meta.tel ?? session.tel ?? "",
    telNormalized: profile?.tel_normalized ?? meta.tel_normalized ?? session.telNormalized ?? "",
    email: authUser.email ?? session.email,
    brand: meta.brand ?? session.brand ?? "",
    position: meta.position ?? session.position ?? "",
    address: meta.address ?? session.address ?? ""
  };
}
